import { render, staticRenderFns } from "./UnidadeLocations.vue?vue&type=template&id=2d572291&scoped=true&"
import script from "./UnidadeLocations.vue?vue&type=script&lang=js&"
export * from "./UnidadeLocations.vue?vue&type=script&lang=js&"
import style0 from "./UnidadeLocations.vue?vue&type=style&index=0&id=2d572291&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d572291",
  null
  
)

export default component.exports